module.exports = __webpack_public_path__ + "img/h2h.2cb74405.svg";